/* Ten Antennas — panel plumbing.

   1. Publish --ta-header-h. Dawn's own --header-height is 0 on this store: it
      comes from the header SECTION's offsetHeight, and the section's custom
      CSS sets position:absolute, which collapses it. A CSS fallback cannot
      cover that — the variable exists, it is just zero.

   2. Relocate the currency and language controls out of the header bar into
      the bottom of the panel. MOVED, not copied — Dawn's localization-form
      carries its own listeners and form state, so a clone would look right
      and submit nothing.

   3. NO SCROLL LOCK. Deliberate, and arrived at the hard way.

      Both usual techniques make the document non-scrollable — `overflow:
      hidden` on the root, or pinning the body with position:fixed. On iOS
      that has an undocumented side effect: Safari expands its bottom toolbar
      back to full size, because there is nothing left to scroll. And Safari
      only tints its chrome from theme-color while that toolbar is COLLAPSED.
      So opening the menu reset the toolbar, and closing it left the status
      bar white until the visitor scrolled again — with the correct colour
      written the whole time. Screenshots showed the identical value #604a44
      tinting before the menu and not after it; the only difference was the
      toolbar's state.

      The panel covers the whole screen and scrolls internally, so locking the
      page behind it buys very little. `overscroll-behavior: contain` on the
      panel stops the scroll chaining through to the page, which is the part
      that actually mattered. */
(function () {
  if (window.__taPanel) return;
  window.__taPanel = true;

  var root = document.documentElement;

  function publishHeight() {
    var el = document.querySelector('header.header');
    if (!el) return;
    var h = Math.round(el.getBoundingClientRect().height);
    if (h > 0) root.style.setProperty('--ta-header-h', h + 'px');
  }

  function relocateLocale() {
    var source = document.querySelector('.header__icons > .desktop-localization-wrapper');
    if (!source) return;
    var panel = document.querySelector('.mega-menu__content');
    if (!panel) return;
    if (!source.children.length) return;

    var host = panel.querySelector('.mega-menu__locale');
    if (!host) {
      host = document.createElement('div');
      host.className = 'mega-menu__locale';
      panel.appendChild(host);
    }
    if (host.contains(source)) return;
    host.appendChild(source);
  }

  /* Clear anything an earlier version of this file may have left behind. */
  function clearLegacyLock() {
    var body = document.body;
    if (!body) return;
    if (root.style.overflow === 'hidden') {
      root.style.overflow = '';
      root.style.paddingRight = '';
    }
    if (body.style.position === 'fixed') {
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      body.style.paddingRight = '';
    }
  }

  function closeOpenMega() {
    document.querySelectorAll('details.mega-menu[open]').forEach(function (details) {
      var host = details.closest('header-menu');
      if (host && typeof host.close === 'function') {
        host.close();
      } else {
        details.removeAttribute('open');
      }
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mega-close]')) {
      event.preventDefault();
      closeOpenMega();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeOpenMega();
  });

  document.addEventListener('toggle', function (event) {
    if (event.target instanceof HTMLDetailsElement && event.target.classList.contains('mega-menu')) {
      publishHeight();
      clearLegacyLock();
    }
  }, true);

  function boot() {
    clearLegacyLock();
    publishHeight();
    relocateLocale();
  }

  window.addEventListener('resize', publishHeight);
  window.addEventListener('load', boot);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  setTimeout(boot, 600);
})();
